import { useFormContext } from 'react-hook-form';
import { faCompactDisc } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';

import { Schema } from '@typings';
import { useImageName } from '@hooks/useImageName';

import { Button, Field, Icon, Modal } from '@components';

import { SchemaImageModal } from './SchemaImageModal';

export const SchemaImage = ({
  error,
  label,
  note,
  name,
  required,
}: Schema.CommonNodeProps) => {
  const { register, setValue, watch } = useFormContext();
  const { getImageName } = useImageName();

  const image: string = watch(name);
  const isImaged = image?.startsWith('image://');

  const handleImagePick = (image: string) => {
    setValue(name, getImageName(image), { shouldValidate: true });
  };

  return (
    <div>
      <div className="flex w-full">
        <Field.Input
          {...register(name)}
          containerClassName="flex-1 relative"
          className={clsx('w-full rounded-r-none', { 'pl-10': isImaged })}
          label={label}
          note={note}
          error={error}
          required={required}
        >
          {isImaged && (
            <div slot="icon" className="absolute left-3.5 top-5">
              <Icon icon={faCompactDisc} className="text-black" />
            </div>
          )}
        </Field.Input>

        <Modal content={<SchemaImageModal onChoose={handleImagePick} />}>
          <Button className="h-14 rounded-l-none">Choose image</Button>
        </Modal>
      </div>
    </div>
  );
};
